export const MAX_LENGTH = 12;
export const INN_ERROR = 'Некорректное значение ИНН';